import { hide, show } from 'lambda-dom'

import { StepElement } from './speak-up.types'

export class SpeakUpStep {

    private readonly ref: string

    constructor(private element: StepElement) {
        this.ref = this.element.dataset.speakupStep
    }

    show(): void {
        show(this.element)
    }

    hide(): void {
        hide(this.element)
    }

    reference(): string {
        return this.ref
    }

    isActive(): boolean {
        return this.element.style.display !== 'none'
    }
}
